/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { fetchAPI, URL_API } from "api";


const ROTA = '/forms/pacotes/questoes-ambientais';

class QuestoesAmbientaisAPI {
    static async getByUUID(uuid: string) {
        const response = await fetchAPI(`${URL_API}${ROTA}/${uuid}`, 'GET', null);
        return response;
    }

    static async update(uuid: string, data: any) {
        const response = await fetchAPI(`${URL_API}${ROTA}/${uuid}`, 'PUT', data);
        return response;
    }
}



export default QuestoesAmbientaisAPI;